export const setView = (data) => {
    return fetch('/customers/user-information/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const logout = () => {
    return fetch('/accounts/logout/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};

export const getUserStatusApi = () =>
    fetch('/customers/account-status/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });

export const getPermissionsApi = () =>
    fetch('/api/v1/entitlements/', {
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });

export const getSubscriptionsApi = async () =>
    fetch('/api/v2/accounts/subscription/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });

export const getMeApi = () =>
    fetch('/api/v1/me/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
